import React from 'react';
import PropTypes from "prop-types";
import { useView } from 'react-view';
import { GuideSectionPropsDescription } from './guide_section_props_description'; // @ts-ignore not TS

import Knobs from '../../../services/playground/knobs'; // @ts-ignore not TS

import { propUtilityForPlayground } from '../../../services/playground';
export var GuideSectionPropsTable = function GuideSectionPropsTable(_ref) {
  var componentName = _ref.componentName,
      component = _ref.component;
  var docgenInfo = Array.isArray(component.__docgenInfo) ? component.__docgenInfo[0] : component.__docgenInfo;
  var props = docgenInfo.props;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(GuideSectionPropsDescription, {
    componentName: componentName,
    component: component
  }), /*#__PURE__*/React.createElement(PlaygroundProps, {
    isPlayground: false,
    config: {
      componentName: componentName,
      props: propUtilityForPlayground(props),
      scope: component
    }
  }));
};
GuideSectionPropsTable.propTypes = {
  componentName: PropTypes.any.isRequired,
  component: PropTypes.any.isRequired
};

var PlaygroundProps = ({
  config,
  isPlayground
}) => {
  const params = useView(config);
  return <Knobs {...params.knobProps} isPlayground={isPlayground} />;
};

try {
  GuideSectionPropsTable.__docgenInfo = {
    description: '',
    displayName: 'GuideSectionPropsTable',
    methods: [],
    props: {
      componentName: {
        defaultValue: null,
        description: '',
        name: 'componentName',
        parent: undefined,
        required: true,
        type: {
          name: 'any'
        }
      },
      component: {
        defaultValue: null,
        description: '',
        name: 'component',
        parent: undefined,
        required: true,
        type: {
          name: 'any'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}